module.exports = __webpack_public_path__ + "img/CTA.799d9309.png";